<script setup lang="ts">
import type { ARServiceItem } from '@/models/airRoad';

import KTextField from '@/components/fields/KTextField.vue';
import DatePickerField from '@/components/pickerFields/DatePickerField.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

const model = defineModel<ARServiceItem>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.newAirRoadSpecialOptionDtRangeFieldset"
    data-testid="newAirRoadSpecialOptionDtRangeFieldset"
  >
    <KTextField
      v-model="model.contact_name"
      size="sm"
      label="Name"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextField
      v-model="model.contact_phone"
      size="sm"
      label="Phone"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <DatePickerField
      v-model="model._dateFrom"
      size="sm"
      label="Date from"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <DatePickerField
      v-model="model._dateTo"
      size="sm"
      label="Date to"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionDtRangeFieldset {
}
  .field {
    margin-top: 0.5rem;
  }
</style>
